import React from "react";
import styled from "styled-components";
import { makeStyles } from "@mui/styles";
import { FormControl, Select, MenuItem, Tooltip } from "@mui/material";

const CustomSelect = styled(Select)`
  height: 100% !important;
  min-width: 50px !important;
  
  &.MuiInput-underline {
    &::before {
      display: none;
    }
    &::after {
      display: none;
    }
  }
  
  .MuiSelect-selectMenu {
    color: #c4c4c4;
    font-size: 10px;
    font-family: "Open Sans";
    font-weight: 600;
    line-height: 15px;
    padding: 5px 15px 5px 10px;
    background: ;
    background-color: ${props => props.transparent === "true" ? "transparent !important" : "#131313 !important"};
    border-radius: 3px;
  }

  .MuiSelect-icon {
    color: #c4c4c4;
    top: calc(50% - 8px);
    right: 3px;
  }
`;

const BlackSelect = (props) => {

  const { transparent, disabled, options, value, onChange, tooltip, tooltipTitle, tooltipLabel, tooltipPlacement } = props;

  const handleDimensionChange = (event) => {
    onChange(event.target.value);
  };

  const CustomTooltip = (props) => {
    const useStyles = makeStyles((theme) => ({
      tooltip: {
        height: '100%',
        color: "white",
        fontSize: "12px !important",
        backgroundColor: "#5A5A5A",
        borderRadius: 3,
        fontFamily: "Roboto",
        padding: "8px 10px",
        marginRight: '10px'
      },
    }));
    const classes = useStyles();
    return <Tooltip classes={classes} {...props} />;
  };

  return (
    <>
      {
        tooltip ?
          <CustomTooltip title={tooltipTitle} aria-label={tooltipLabel} placement={tooltipPlacement}>
            <CustomSelect value={value} onChange={handleDimensionChange}>
              {options.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </CustomSelect>
          </CustomTooltip> :
          <FormControl disabled={disabled}>
            <CustomSelect value={value} onChange={handleDimensionChange} transparent={transparent}>
              {options.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </CustomSelect>
          </FormControl>          
      }      

    </>
  );
};

export default BlackSelect;
